export const ROUTE_INTEGRATIONS = `/integrations`
export const ROUTE_INTEGRATIONS_ONBOARDING = `${ROUTE_INTEGRATIONS}/onboarding`
export const ROUTE_INTEGRATIONS_ONBOARDING_FAIL = `${ROUTE_INTEGRATIONS_ONBOARDING}/fail`
export const ROUTE_INTEGRATIONS_OVERVIEW = `${ROUTE_INTEGRATIONS}/overview`
